import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthContext';
import { Path } from '@/enums';

const ProtectedRoute = () => {
  const { token, profile, profileLoading } = useAuth();

  if (!token) {
    return <Navigate to={Path.Login} replace />;
  }

  if (profileLoading) {
    return null;
  }

  return profile ? <Outlet /> : <Navigate to={Path.Login} replace />;
};

export default ProtectedRoute;
